export class TrafficFrom {
  public static Recommended = "recommended";
  public static Search = "search";
  public static Autocomplete = "autocomplete";
  public static External = "external";
}
